/**
 * Boşta kalma sayacı (#570): `minutes` boyunca fare/klavye/dokunma yoksa `true` olur,
 * ilk harekette `false`'a döner ve sayaç baştan başlar. Dinleyiciler pasif; her harekette
 * yalnız zamanlayıcı kurulur (ucuz), state ancak boşta→aktif geçişinde değişir.
 */
import { useEffect, useState } from 'react';

export const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'wheel',
  'pointerdown',
] as const;

export function useIdle(enabled: boolean, minutes: number): boolean {
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    if (!enabled || !(minutes > 0)) {
      setIdle(false);
      return;
    }
    const ms = minutes * 60_000;
    let timer = window.setTimeout(() => setIdle(true), ms);
    const reset = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setIdle(true), ms);
      setIdle(false);
    };
    for (const ev of ACTIVITY_EVENTS) window.addEventListener(ev, reset, { passive: true });
    return () => {
      window.clearTimeout(timer);
      for (const ev of ACTIVITY_EVENTS) window.removeEventListener(ev, reset);
    };
  }, [enabled, minutes]);
  return enabled && idle;
}
